<template lang="pug">
  section

    el-breadcrumb
      el-breadcrumb-item Marketing
      el-breadcrumb-item
        b Cupons de presente

    SearchList(
      context="subscription-gift-coupon"
      :service="subscriptionGiftCouponService"
      defaultSortColumn="createdAt"
      defaultSortDirection="desc"
    )
      template(slot="tableRows")

        el-table-column(prop="couponCodes", label="Cupom", width="240", :show-overflow-tooltip="true" , sortable)
          template(scope="scope")
            | {{ scope.row.couponCodes.join(', ') }}

        el-table-column(prop="giftDescription" label="Descrição" :show-overflow-tooltip="true")

        el-table-column(prop="availableRedeems" label="Qtd. disponível" width="110")

        el-table-column(prop="active", label="Ativo", width="100", sortable)
          template(scope="scope")
            span(v-if="scope.row.active" style="color: #67C23A") Ativo
            span(v-else style="color: #F56C6C") Inativo


        el-table-column(prop="createdAt" label="Criado" width="110", sortable)
          template(scope="scope")
            span {{ fromSystemDate(scope.row.createdAt) }}

</template>
<script setup>
import { computed }  from 'vue'
import moment from 'moment';

import SubscriptionGiftCouponService from '@/services/promotions/SubscriptionGiftCouponService';
import SearchList from '@/components/list/SearchList.vue';

const subscriptionGiftCouponService = SubscriptionGiftCouponService

const fromSystemDate = (value) => {
  return value ? moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
}
</script>
